import { insertLink } from './operations';

const slashMenu = {
  Link: {
    icon: 'link',
    basic: true,
    shortcut: '[Title](URL)',
    transform: insertLink,
  },
};

export default slashMenu;
